import { render, staticRenderFns } from "./StoreDeactivateTransferDialog.vue?vue&type=template&id=d866bfe2&scoped=true"
import script from "./StoreDeactivateTransferDialog.vue?vue&type=script&lang=js"
export * from "./StoreDeactivateTransferDialog.vue?vue&type=script&lang=js"
import style0 from "./StoreDeactivateTransferDialog.vue?vue&type=style&index=0&id=d866bfe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d866bfe2",
  null
  
)

export default component.exports